<template>
  <div id="app">
    <el-container>
      <el-header v-if="showLayout">
        <div class="logo">
          <img src="./assets/img/toplogo.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          :router="router"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item @click="download" index="">下载收银宝电脑端</el-menu-item>
          <el-menu-item @click="toDoc" index="">开发文档</el-menu-item>
          <el-menu-item index="/concat">联系我们</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" id="footer" v-if="showLayout">
        <div class="footer-content">
          <div style="display: flex;justify-content: space-between;width: 100%">
            <div>
              <ul class="content-nav">
                <li>
                  <p>联系我们</p>
                  <span>服务电话：010-5747-1881</span>
                  <span>
                  <a style="color:white;display: flex;align-items: center" href="tencent://message/?uin=3588888584&Menu=yes" target="_blank">QQ:3588888584
                    <img src="./assets/img/qq.png" style="width: 20px;height:20px" />
                  </a>
                </span>
                </li>
              </ul>
            </div>
            <div style="flex:1;display: flex;justify-content: flex-end">
              <img src="./assets/img/wx.png" />
              <img src="./assets/img/mp.png" />
            </div>
            <div>
            </div>
          </div>
          <div style="display: flex;justify-content: center;padding-top: 30px;color: white">
            <div>ICP备案号：京ICP备2024096988号-1</div>
            <div style="margin-left:30px">
              <router-link style="color:#16a3d0;text-decoration: none;" to="/pay">支付清算协会备案证明</router-link>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
  import request from './utils/request'

export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      showLayout: true
    };
  },
  watch: {
    '$route'(to) {
      this.showLayout = to.fullPath !== '/doc'
    }
  },
  methods: {
    download() {
      request.get('https://www.yqdfpay.com/api/update/version2').then(res => {
        if(res.code === 0) {
          window.open(res.data.url)
        }
      }).catch(err => {
        console.info(err)
      })
    },
    toDoc(){
      window.open("/doc")
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 160px;
    padding: 10px;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 296px;
  overflow: hidden;
  background-color: #14679f;
  &-content {
    width: 800px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
